
/* START_TEMPLATE */
define('hbs!pricelist/templates/information',['hbs','handlebars','templates/helpers/unlessZero'], function( hbs, Handlebars ){ 
var t = Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [2,'>= 1.0.0-rc.3'];
helpers = helpers || Handlebars.helpers;
  var buffer = "", stack1, stack2, options, functionType="function", escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\r\n                    <div class=\"table\">\r\n                        <div class=\"table-content\">\r\n                            <table>\r\n                                <tr>\r\n                                    <th>Typ</th>\r\n                                    <th>Text</th>\r\n                                </tr>\r\n                                ";
  stack2 = helpers.each.call(depth0, ((stack1 = depth0.information),stack1 == null || stack1 === false ? stack1 : stack1.MediaTexts), {hash:{},inverse:self.noop,fn:self.program(2, program2, data)});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\r\n                            </table>\r\n                        </div>\r\n                    </div>\r\n                    ";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\r\n                                <tr>\r\n                                    <td>";
  if (stack1 = helpers.TextTypeName) { stack1 = stack1.call(depth0, {hash:{}}); }
  else { stack1 = depth0.TextTypeName; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</td>\r\n                                    <td>";
  if (stack1 = helpers.Text) { stack1 = stack1.call(depth0, {hash:{}}); }
  else { stack1 = depth0.Text; stack1 = typeof stack1 === functionType ? stack1.apply(depth0) : stack1; }
  buffer += escapeExpression(stack1)
    + "</td>\r\n                                </tr>\r\n                                ";
  return buffer;
  }

function program4(depth0,data) {
  
  
  return "\r\n                    Information saknas.\r\n                    ";
  }

  buffer += "<div class=\"card no-margin-top\">\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-12\">\r\n            <div class=\"card-wraper\">\r\n                <div class=\"card-body\">\r\n                    ";
  options = {hash:{},inverse:self.program(4, program4, data),fn:self.program(1, program1, data)};
  stack2 = ((stack1 = helpers.unlessZero),stack1 ? stack1.call(depth0, ((stack1 = depth0.information),stack1 == null || stack1 === false ? stack1 : stack1.MediaTexts), options) : helperMissing.call(depth0, "unlessZero", ((stack1 = depth0.information),stack1 == null || stack1 === false ? stack1 : stack1.MediaTexts), options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>";
  return buffer;
  });
Handlebars.registerPartial('pricelist_templates_information', t);
return t;
});
/* END_TEMPLATE */
;
